import { render, staticRenderFns } from "./IncidentCreationView.vue?vue&type=template&id=15d50fc4"
import script from "./IncidentCreationView.vue?vue&type=script&lang=js"
export * from "./IncidentCreationView.vue?vue&type=script&lang=js"
import style0 from "./IncidentCreationView.vue?vue&type=style&index=0&id=15d50fc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports